import CookiesJS from 'cookies-js';

export function initRecipes($, apiClient) {
    function extractArrayItems(field) {
        const items = [];
        $(`#${field} .array-item .array-item-value`).each(function () {
            items.push($(this).val());
        });
        return items;
    }

    $('form.recipe-form .action__entity-save').on('click', async function () {
        try {
            const _id = $(this).attr('data-object-id');
            const composition = [];
            const images = [];
            $('#images .upload-images__image-container').each(function () {
                images.push($(this).attr('data-key'));
            });
            $('#composition .array-item').each(function () {
                composition.push({
                    productId: $(this).find('select.productId').val(),
                    weight: parseFloat($(this).find('.weight').val()),
                    units: $(this).find('.units').val(),
                    unitsQuantity: parseFloat($(this).find('.unitsQuantity').val()),
                    required: !!$(this).find('.required').prop('checked'),
                });
            });
            const recipe = {
                title: $('#title').val(),
                nationality: $('#nationality').val(),
                description: $('#description').val(),
                images,
                cookingSteps: extractArrayItems('cookingSteps'),
                time: parseFloat($('#time').val()),
                videoUrl: $('#videoUrl').val(),
                isOfficeFriendly: !!$('#isOfficeFriendly').prop('checked'),
                minPortion: parseFloat($('#minPortion').val()),
                maxPortion: parseFloat($('#maxPortion').val()),
                difficulty: parseFloat($('#difficulty').val()),
                price: parseFloat($('#price').val()),
                kitchenware: $('#kitchenware').val(),
                author: $('#author').val(),
                method: extractArrayItems('method'),
                tags: extractArrayItems('tags'),
                mealTypes: [
                    $('#mealTypes0').prop('checked') ? 0 : undefined,
                    $('#mealTypes1').prop('checked') ? 1 : undefined,
                    $('#mealTypes2').prop('checked') ? 2 : undefined,
                    $('#mealTypes3').prop('checked') ? 3 : undefined,
                    $('#mealTypes4').prop('checked') ? 4 : undefined,
                    $('#mealTypes5').prop('checked') ? 5 : undefined
                ].filter(item => item !== undefined),
                adjustable: !!$('#adjustable').prop('checked'),
                composition,
                deleted: !!$('#deleted').prop('checked'),
            };
            if (!_id) {
                const result = await apiClient.create('/recipes', recipe, CookiesJS.get('auth_token'));
                console.log(result);
                document.location.href=`/recipes/edit/${result._id}`;
            } else {
                const result = await apiClient.updateOne('/recipes', _id, recipe, CookiesJS.get('auth_token'));
                console.log(result);
                alert('Сохранено');
                location.reload();
            }
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
